import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { CommentIcon, LikeHollowIcon, ViewCountIcon } from '../icons';
import withTranslate from '../../hoc/with-translate';
import styles from './post-list-classic-header.scss';

const PostListClassicHeader = ({ t }) =>
  <thead>
    <tr className={styles.row}>
      <th className={styles.avatarHeader}/>
      <th className={classNames(styles.titleHeader, styles.left, 'forum-text-color')}>
        {t('post-list-classic.title')}
      </th>
      <th className={classNames(styles.iconHeader, styles.right)}>
        <ViewCountIcon className="forum-icon-fill" title={t('post-list-classic.views')}/>
      </th>
      <th className={classNames(styles.iconHeader, styles.right)}>
        <CommentIcon className="forum-icon-stroke" title={t('post-list-classic.comments')}/>
      </th>
      <th className={classNames(styles.iconHeader, styles.right)}>
        <LikeHollowIcon className="forum-icon-stroke" title={t('post-list-classic.likes')}/>
      </th>
      <th className={classNames(styles.timeAgoHeader, styles.left, 'forum-text-color')}>
        {t('post-list-classic.recent-activity')}
      </th>
      <th className={styles.moreButtonHeader}/>
    </tr>
  </thead>;

PostListClassicHeader.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslate(PostListClassicHeader);



// WEBPACK FOOTER //
// ./app/components/post-list-classic-header/post-list-classic-header.js